import React from 'react';
import {
    Button, Form, FormGroup, Label, Input,
    Col,
    Container, Row
} from 'reactstrap';

import SelectListComponent from '../../utils/selectList';
import DateSelector from '../../utils/dateSelector';


const AllratesPanel = ({
    currencyOptions,
    countryOptions,
    statusOptions,
    selectedCurrencyCode,
    selectedCountryCode,
    selectedStatus,
    onCurrencyCodeChange,
    onCountryCodeChange,
    onStatusChange,
    onSearch,
    startDate,
    endDate,
    startDateChange,
    endDateChange,
}) => {
    return (
        <Form onSubmit={e => e.preventDefault()}>
            <Container>
                <Row>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-4">
                            <Label>Start Date</Label>
                            <DateSelector 
                            maxDate={new Date()}
                            todayDate={(startDate || new Date()).toString()}
                            name="startDate" onValueChange={startDateChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-4">
                            <Label>End Date</Label>
                            <DateSelector 
                            maxDate={new Date()}
                            todayDate={(endDate || new Date()).toString()}
                            name="endDate" onValueChange={endDateChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-4">
                            <Label>Currency Code</Label>
                            <Input
                                type="text"
                                value={selectedCurrencyCode || ''}
                                placeholder="e.g. NGN"
                                onChange={(e) => onCurrencyCodeChange && onCurrencyCodeChange(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-4">
                            <Label>Country Name</Label>
                            <SelectListComponent data={countryOptions} valueKey='Name' textField='Name' selectValue={selectedCountryCode} onValueChange={onCountryCodeChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-4">
                            <Label>Status</Label>
                            <SelectListComponent data={statusOptions} valueKey='value' textField='label' selectValue={selectedStatus} onValueChange={onStatusChange} />
                        </FormGroup>
                    </Col>
                   <Col xs="6" sm="2" className="d-flex align-items-end mb-4"> <Button className="btn-avi-primary mr-0" onClick={() => onSearch(1)}>Search</Button> </Col>
                </Row>
            </Container>
            
        </Form>
    )
};



export default AllratesPanel;



// WEBPACK FOOTER //
// ./src/views/exchange-rate/AllRates/AllratesPanel.js